import { Badge } from "antd";
import React, { ReactSVG } from "react";
import styles from "./badge.module.scss";

type TProps = {
  count: string;
  selected?: boolean;
  disabled?: boolean;
  leftIcon?: React.JSX.Element | string;
  onClick: () => void;
};
const SelectableBadge = ({ count, selected, leftIcon, onClick, disabled }: TProps) => {
  const componentName = "badge";
  return (
    <span
      onClick={() => {
        if (!disabled) onClick();
      }}
    >
      <Badge
        count={
          <>
            {leftIcon}
            {count}
          </>
        }
        className={
          disabled && selected
            ? `${styles[`${componentName}-badge-selected-disabled`]}`
            : disabled && !selected
              ? `${styles[`${componentName}-badge-disabled`]}`
              : selected
                ? `${styles[`${componentName}-badge-selected`]}`
                : `${styles[`${componentName}-badge`]}`
        }
      />
    </span>
  );
};

SelectableBadge.defaultProps = {
  selected: false,
};

export default SelectableBadge;
